import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import first from 'lodash/first';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';

// Structure images path from BE response, PATH_PLANNER_S is png image
import { PATH_PLANNER_S } from '@Pages/RetroSynthesis/constants';

import { buildTreeFromList } from '@Pages/RetroSynthesis/ProjectRoute/utils/treeDataBuilder';
import ProjectRouteTree from '@Pages/RetroSynthesis/ProjectRoute/ProjectRouteTreeView/components/ProjectRouteTree';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

import './RouteOverviewTreePopup.theme.scss';

function RouteOverviewTreePopup({ isLoading, treeList, routeName, className, isPredictedRoute, ...rest }) {
  const tree = first(buildTreeFromList(treeList));

  return (
    <GeneralDialogLayout
      {...rest}
      size="sm"
      movable={false}
      className={cn(className, 'react-dialogs-scrollable route-overview-tree-popup')}
      header={<h4>{routeName}</h4>}>
      <div className="route-overview-tree-popup__container">
        {isLoading ? (
          <SimpleSpinner />
        ) : (
          <ProjectRouteTree
            data={tree}
            zoom={0.75}
            zoomEnabled={false}
            autoSize
            structureImagesPath={PATH_PLANNER_S}
            nodesDisabled
            isPredictedRoute={isPredictedRoute}
            addNodeEnabled={false}
          />
        )}
      </div>
    </GeneralDialogLayout>
  );
}

RouteOverviewTreePopup.propTypes = {
  isLoading: PropTypes.bool,
  treeList: PropTypes.array,
  routeName: PropTypes.string,
  className: PropTypes.string,
  isPredictedRoute: PropTypes.bool,
};

export const typeOfRouteOverviewTreeDialog = 'typeOfRouteOverviewTreeDialog';
export default RouteOverviewTreePopup;
